/**
 * The creator's whole world: drop clips, watch them land; the avatar menu signs out. Built from
 * design/canvas/CreatorUpload.src.html. Studio roles can open it too; the shared UploadPanel does the
 * work on both this page and the in-shell Upload page.
 */
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useRouteContext } from '@tanstack/react-router';
import { PRODUCT_NAME } from '@studio/contracts';
import { Icon } from '@/components/icons';
import { ProfileMenu } from '@/components/profile-menu';
import { UploadPanel } from '@/components/upload-panel';
import { trpc } from '@/lib/trpc';

export function CreatorUploadPage() {
  const { me } = useRouteContext({ from: '/creator' });
  const navigate = useNavigate();
  const profile = useQuery(trpc.upload.profile.queryOptions());
  const isCreator = me.active?.role === 'creator';
  const firstName = (profile.data?.name ?? me.displayName ?? '').split(' ')[0] || null;

  return (
    <div className="creator-page">
      <header className="creator-top">
        <div className="brand-block creator-brand">
          <div className="mark"><Icon name="lines" /></div>
          <div className="grow">
            <div className="name">{PRODUCT_NAME}</div>
            <div className="tenant">{me.active?.brandName}</div>
          </div>
        </div>
        <div className="creator-top-right">
          <span className="chip">{isCreator ? 'Creator' : 'Studio'}{firstName ? ` · ${firstName}` : ''}{profile.data?.country ? ` · ${profile.data.country}` : ''}</span>
          <ProfileMenu me={me} avatarClass="creator" items={isCreator ? [] : [{ label: 'Back to the studio', onClick: () => void navigate({ to: '/upload' }) }]} />
        </div>
      </header>
      <main className="creator-body">
        <div className="creator-lead">
          <h1>Drop your clips here{firstName ? `, ${firstName}` : ''}</h1>
          <p className="sub">Anything you upload is filed to {me.active?.brandName} under your name. We take it from there.</p>
        </div>
        <UploadPanel brandName={null} />
        <p className="sub creator-foot">Received means it is safely stored. In the studio means the editors have picked it up.</p>
      </main>
    </div>
  );
}
